import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class StoreService {
  storeData: any = {};
  url: string = `${environment.apiUrl}v1/Store`;

  constructor(private http: HttpClient) {}

  private header() {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return headers;
  }
  getStores() {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.url}/List`, { headers });
  }
  addNewStore(storeInfo: any) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.post(`${this.url}/RegisterStore`, storeInfo, { headers });
  }

  getStoreById(storeId: number) {
    return this.http.get(`${this.url}/${storeId}`, {
      headers: this.header(),
    });
  }

  deleteStore(storeId: number) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.delete(`${this.url}/DeleteStore/${storeId}`, { headers });
  }

  getStoreAdmins(storeId: number) {
    return this.http.get(`${this.url}/${storeId}/Admins`, {
      headers: this.header(),
    });
  }

  activateStore(storeId: number) {
    return this.http.put(
      `${this.url}/Activate/${storeId}`,
      {},
      { headers: this.header() },
    );
  }

  getToken(): string | null {
    const name = 'authToken=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        const token = cookie.substring(name.length);
        return token;
      }
    }
    return null;
  }
}
